import React from "react";
import { IWithCustomScroll, withCustomScroll } from "custom-horizontal-scroll";
import { Table } from "./Table";

const Layout = (props: IWithCustomScroll) => {
  return (
      <div id={props.customScroll.id} className="layout-container">
        <Table />
      </div>
  );
};

export default withCustomScroll(Layout);
